import React from "react";
import Layout from "../../layout/adminExt/Layout";
import AgentManagement from "./AgentManagement";

export default function Index() {
  return (
    <Layout>
      <AgentManagement />
    </Layout>
  );
}
